import { useEffect, useState } from "react";
import { Bot, Inbox, Receipt, AlertCircle, TrendingUp, Sunrise, Check } from "lucide-react";
import { cn } from "@/lib/utils";

const ACTIONS = [
  { icon: Inbox, color: "text-blue-500", bg: "bg-blue-500/10", text: "Replied to Sarah about Tuesday's appointment" },
  { icon: Receipt, color: "text-emerald-500", bg: "bg-emerald-500/10", text: "Generated invoice #1247 for completed cleaning job" },
  { icon: AlertCircle, color: "text-amber-500", bg: "bg-amber-500/10", text: "Sent friendly reminder for invoice #1239 ($420 overdue)" },
  { icon: TrendingUp, color: "text-purple-500", bg: "bg-purple-500/10", text: "Categorized 14 bank transactions automatically" },
  { icon: Sunrise, color: "text-orange-500", bg: "bg-orange-500/10", text: "Morning briefing: Revenue up 23% MTD — 4 new accounts" },
];

export const AutopilotShowcase = () => {
  const [visible, setVisible] = useState<number[]>([]);

  useEffect(() => {
    const timers: number[] = [];
    ACTIONS.forEach((_, i) => {
      timers.push(window.setTimeout(() => setVisible((p) => [...p, i]), 600 + i * 700));
    });
    timers.push(window.setTimeout(() => setVisible([]), ACTIONS.length * 700 + 4000));
    const interval = window.setInterval(() => {
      setVisible([]);
      ACTIONS.forEach((_, i) => {
        timers.push(window.setTimeout(() => setVisible((p) => [...p, i]), 600 + i * 700));
      });
    }, ACTIONS.length * 700 + 6000);
    return () => {
      timers.forEach(clearTimeout);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="relative rounded-2xl border border-border bg-card shadow-2xl overflow-hidden">
      <div className="flex items-center gap-3 px-5 py-3 border-b bg-muted/30">
        <div className="rounded-lg bg-primary/10 p-1.5">
          <Bot className="h-4 w-4 text-primary" />
        </div>
        <div className="text-sm font-semibold">AutoPilot · live activity</div>
        <div className="ml-auto flex items-center gap-1.5">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
          </span>
          <span className="text-xs text-muted-foreground">running</span>
        </div>
      </div>
      <div className="p-4 space-y-2 min-h-[280px]">
        {ACTIONS.map((a, i) => {
          const Icon = a.icon;
          const isVisible = visible.includes(i);
          return (
            <div
              key={i}
              className={cn(
                "flex items-start gap-3 rounded-lg border bg-background/50 p-3 transition-all duration-500",
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"
              )}
            >
              <div className={cn("rounded-md p-1.5 shrink-0", a.bg)}>
                <Icon className={cn("h-4 w-4", a.color)} />
              </div>
              <div className="flex-1 text-sm">{a.text}</div>
              <Check className="h-4 w-4 text-emerald-500 shrink-0 mt-0.5" />
            </div>
          );
        })}
      </div>
    </div>
  );
};
